<template>
  <div>
    <b-modal id="item-add-dialog" ref="item-add-dialog" title="Zutat / Material hinzufügen"
             @ok="submitForm" @hide="close" :busy="isSaving">
      <b-form-group
          description="Bitte Zutat oder Material auswählen"
          label="Zutat / Material"
          label-for="add-ingrecient-select"
          :invalid-feedback="ingredientFeedback"
          :state="ingredientState"
      >
        <v-multiselect id="add-ingrecient-select" v-model="ingredient" :options="filterOptions.ingredients"
                  track-by="value" label="text" :show-labels="false" :searchable="true" :disabled="isSaving">
        </v-multiselect>
      </b-form-group>
      <b-form-group
          description="Bitte Zutat oder Material auswählen"
          label="Menge"
          label-for="add-ingredient-amount"
          :invalid-feedback="amountFeedback"
          :state="amountState"
      >
        <b-input-group :append="ingredient ? ingredient.base_unit_title : 'Einheit'">
          <b-form-input type="number" v-model="amount"
                        :step="Math.pow(10, (ingredient ? ingredient.base_unit_precision : 1) * -1)"
                        @keydown.enter.native="submitDelta" :disabled="isSaving"
                        ></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import HelperMixin from "./HelperMixin"
const axios = require('axios');

export default {
  props: [ 'items', 'filterOptions', 'apiUrl' ],
  mixins: [ HelperMixin ],
  data() {
    return {
      isSaving: false,
      ingredient: null,
      amount: 0,
      ingredientFeedback: '',
      amountFeedback: '',
    }
  },
  computed: {
    ingredientState() {
      let valid = true
      if (this.ingredient === null) {
        valid = null
        this.ingredientFeedback = 'Bitte eine Zutat / Material auswählen!'
      } else {
        let search = this.items.find(obj => {
          return obj.ingredient_id === this.ingredient.value
        })
        if (search) {
          valid = false
          this.ingredientFeedback = 'Die gewählte Zutat / Material ist bereits auf der Einkaufsliste vorhanden, bitte dort bearbeiten!'
        } else {
          this.ingredientFeedback = ''
        }
      }
      return valid
    },
    amountState() {
      let valid = true
      if (this.amount < 0) {
        valid = false
        this.amountFeedback = 'Es muss ein Wert größer Null eingegeben werden!'
      } else if (this.amount === 0) {
        valid = null
        this.amountFeedback = 'Bitte die gewünschte Menge eingeben!'
      } else {
        this.amountFeedback = ''
      }
      return valid
    }
  },
  mounted() {

  },
  methods: {
    close() {
      this.isSaving = false
      this.ingredient = null
      this.amount = 0
      this.ingredientFeedback = ''
      this.amountFeedback = ''
    },
    submitForm(bvModalEvent) {
      bvModalEvent.preventDefault()

      if (this.ingredientState && this.amountState) {
        this.isSaving = true
        axios.put(this.apiUrl, {
          amount_delta: this.amount,
        }, {
          params: {
            id: this.ingredient.value,
          }
        }).then((result) => {
          let item = this.items.find(obj => {
            return obj.ingredient_id === result.data.ingredient_id
          })
          // only add item if it has not yet been added by the Pusher call
          if (item) {
            item.amount_needed = result.data.amount_needed
            item.amount_shopping = result.data.amount_shopping
            item.amount_available = result.data.amount_available
            item.amount_delta = result.data.amount_delta
            item.is_shopped = result.data.is_shopped
          } else {
            this.items.push(result.data)
          }
          this.$refs['item-add-dialog'].hide()
        }).catch(error => {
          // maybe handle errors somehow?
        })
      }
    }
  }
}
</script>

<style scoped>

</style>